<template>
  <div class="station-statistics">

    <!-- START Search Box -->
    <div class="row">
      <div class="col-lg-12">
        <div class="card shadow">
          <div class="card-body">
            <div class="row">
              <div class="col-xl-3 col-lg-6">
                <b-form-group class="ct-mb-margin-bottom-100" label-class="col-form-label"
                              label="조회 기간" label-for="searchPeriod"
                              label-cols="3" content-cols="9">
                  <date-picker id="searchPeriod" v-model="searchForm.period"
                               range value-type="format" append-to-body lang="ko"
                               :disabled-date="disabledAfterYesterday" @input="search">
                    <template v-slot:footer="{ emit }">
                      <div class="text-start">
                        <b-button size="sm" variant="outline-primary me-1" @click="$_utils.periodOneMonth(emit, 'yesterday')">
                          1개월
                        </b-button>
                        <b-button size="sm" variant="outline-primary me-1" @click="$_utils.periodThreeMonth(emit, 'yesterday')">
                          3개월
                        </b-button>
                        <b-button size="sm" variant="outline-primary" @click="$_utils.periodSixMonth(emit, 'yesterday')">
                          6개월
                        </b-button>
                      </div>
                    </template>
                  </date-picker>
                </b-form-group>
              </div>
              <div class="col-xl-5 col-lg-6">
                <b-form-group class="ps-lg-3" label-class="form-check-label me-lg-3"
                              label="충전기 유형" label-for="searchEvseType"
                              label-cols="3" label-cols-lg="auto">
                  <div id="searchEvseType" class="col-form-label">
                    <div class="form-check form-check-inline" v-for="(evse, i) in evseTypeOptions">
                      <input class="form-check-input" type="radio" :id="`stationRadio${i}`"
                             :value="`${evse.value}`" v-model="searchForm.evseType"
                             @change="search" />
                      <label class="form-check-label" :for="`stationRadio${i}`">{{ evse.name }}</label>
                    </div>
                  </div>
                </b-form-group>
              </div>
<!--              <search-buttons layout-class="col-lg-6 ct-margin-top-25"-->
<!--                              resetBtnClass="search-btn-reset" searchBtnClass="search-btn-search"-->
<!--                              :reset-fn="reset" :search-fn="search" />-->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- END Search Box -->

    <!-- START Info Box -->
    <div class="row">
      <div class="col-md-6 col-lg-2">
        <info-count-to card-bg="lh-soft-blue"
                       icon-image="mdi-office-building-marker" icon-color="lh-soft-blue"
                       title="충전소" value-title="개"
                       :end-val="$_utils.isEmpty(result.usedCount) ? 0 : result.usedCount.placeCountSum"
                       :tot-val="$_utils.isEmpty(result.usedCount) ? 0 : result.usedCount.placeTotalCountSum" />
      </div>
      <div class="col-md-6 col-lg-2">
        <info-count-to card-bg="lh-green"
                       icon-image="mdi-ev-station" icon-color="lh-green"
                       title="충전기" value-title="기"
                       :end-val="$_utils.isEmpty(result.usedCount) ? 0 : result.usedCount.evseCountSum"
                       :tot-val="$_utils.isEmpty(result.usedCount) ? 0 : result.usedCount.evseTotalCountSum" />
      </div>
      <div class="col-md-6 col-lg-2">
        <info-count-to card-bg="success" icon-image="mdi-account-multiple-check" icon-color="success"
                       title="이용" valueTitle="건"
                       :end-val="$_utils.isEmpty(result.usedCount) ? 0 : result.usedCount.chargeCount" />
      </div>
      <div class="col-md-6 col-lg-2">
        <info-count-to card-bg="info" icon-image="mdi-account-group" icon-color="info"
                       title="이용자" value-title="명"
                       :end-val="$_utils.isEmpty(result.usedCount) ? 0 : result.usedCount.chargeUserCount" />
      </div>

      <div class="col-md-6 col-lg-2">
        <info-count-to card-bg="primary" icon-image="mdi-battery-charging-high" icon-color="primary"
                       title="충전량" valueTitle="kWh"
                       :end-val="$_utils.isEmpty(result.usedCount) ? 0 : result.usedCount.chargeEnergy" />
      </div>
      <div class="col-md-6 col-lg-2">
        <info-count-to card-bg="danger" icon-image="mdi-cash-multiple" icon-color="danger"
                       title="충전 금액" valueTitle="원"
                       :end-val="$_utils.isEmpty(result.usedCount) ? 0 : result.usedCount.chargeCost" />
      </div>
    </div>
    <!-- END Info Box -->

    <div class="row">
      <!-- START Usage By Type Chart -->
      <div class="col-lg-6">
        <div class="card shadow">
          <div class="card-body">
            <card-title icon-image="mdi-chart-bar" title="충전소 유형" text-color="title" />
            <div class="mt-3">
              <apexchart ref="stationChart1" height="200" :options="chartBarOptions" :series="chartBarOptions.series" />
            </div>
          </div>
        </div>
      </div>
      <!-- END Usage By Type Chart -->

      <!-- START Usage By Type List -->
      <div class="col-lg-6">
        <div class="card card-height-100 shadow">
          <div class="card-body">
            <card-title icon-image="mdi-table-large" title="충전소 유형 상세" text-color="title" />
            <div class="type-use-table">
              <b-table class="datatables text-nowrap"
                       :sort-by.sync="typeSortBy"
                       :sort-desc.sync="typeSortDesc"
                       :fields="fields" :items="!$_utils.isEmpty(result.usedList) ? result.usedList : null">
                <template #cell(placeType)="data">
                  {{ $_app.code.placeType[data.item.placeType] }}
                </template>
                <template #cell(placeCount)="data">
                  <span class="ct-text-main">{{ $_utils.comma(data.item.placeCount) }}</span>
                  <span> / </span>
                  {{ $_utils.comma(data.item.placeTotalCount) }}
                </template>
                <template #cell(evseCount)="data">
                  <span class="ct-text-main">{{ $_utils.comma(data.item.evseCount) }}</span>
                  <span> / </span>
                  {{ $_utils.comma(data.item.evseTotalCount) }}
                </template>
                <template #cell(chargeUserCount)="data">
                  {{ $_utils.comma(data.item.chargeUserCount) }}
                </template>
                <template #cell(chargeCount)="data">
                  {{ $_utils.comma(data.item.chargeCount) }}
                </template>
                <template #cell(chargeEnergy)="data">
                  {{ $_utils.comma(data.item.chargeEnergy) }}
                </template>
                <template #cell(chargeCost)="data">
                  {{ $_utils.comma(data.item.chargeCost) }}
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </div>
      <!-- END Usage By Type List -->
    </div>

    <div class="row">
      <!-- START Group Chart -->
      <div class="col-lg-6">
        <div class="card shadow">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6 mb-2">
                <b-form-group class="ct-mb-margin-bottom-50" label-class="col-form-label"
                              label="충전소 유형" label-for="searchStationType"
                              label-cols="3" content-cols="9">
                  <multiselect id="searchStationType"
                               v-model="searchForm.stationType" :options="stationTypeOptions"
                               label="text" placeholder="" select-label=""
                               :allow-empty="false" deselect-label=""
                               @input="searchCondition('place')" />
                </b-form-group>
              </div>
              <div class="col-md-6 mb-2">
                <b-form-group class="ct-mb-margin-bottom-50" label-class="col-form-label"
                              label="충전소" label-for="searchStationName"
                              label-cols="3" content-cols="9">
                  <multiselect id="searchStationName"
                               v-model="searchForm.stationName" :options="stationNameOptions"
                               label="text" placeholder="" select-label=""
                               :allow-empty="false" deselect-label=""
                               @input="getChartItems()" />
                </b-form-group>
              </div>
            </div>
            <div class="mt-4">
              <div>
                <apexchart ref="stationGroupChart3" type="line" height="160"
                           :options="groupChartOptions3" :series="groupChartOptions3.series" />
              </div>
              <div>
                <apexchart ref="stationGroupChart1" type="line" height="160"
                           :options="groupChartOptions1" :series="groupChartOptions1.series" />
              </div>
              <div>
                <apexchart ref="stationGroupChart2" type="line" height="160"
                           :options="groupChartOptions2" :series="groupChartOptions2.series" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- END Group Chart -->

      <!-- START Station Usage List -->
      <div class="col-lg-6">
        <div class="card card-height-100 shadow">
          <div class="card-body">
            <h4 class="card-title mb-3">
              <span class="icon-padding-right ct-card-title">
                <i class="mdi mdi-table-large" />
              </span>
              <template v-if="searchForm.stationName.value !== 'all'">
                <span class="text-lh-green ct-padding-right-25">
                  {{ searchForm.stationName.text }}
                </span>
                <span class="ct-card-title">충전기 이용 상세</span>
              </template>
              <template v-else>
                <span class="text-lh-green ct-padding-right-25" v-if="searchForm.stationType.value !== 'all'">
                  {{ $_app.code.placeType[searchForm.stationType.value] }}
                </span>
                <span class="ct-card-title">충전소 이용 내역</span>
              </template>
            </h4>
            <div class="use-lank-table">
              <b-table class="datatables text-nowrap"
                       :sort-by.sync="useSortBy"
                       :sort-desc.sync="useSortDesc"
                       :fields="useFields" :items="useItems">
                <template #cell(placeType)="data">
                  {{ $_app.code.placeType[data.item.placeType] }}
                </template>
                <template #cell(capacity)="data">
                  {{ $_utils.comma(data.item.capacity) }}
                </template>
                <template #cell(evseCount)="data">
                  {{ $_utils.comma(data.item.evseCount) }}
                </template>
                <template #cell(chargeUserCount)="data">
                  {{ $_utils.comma(data.item.chargeUserCount) }}
                </template>
                <template #cell(chargeCount)="data">
                  {{ $_utils.comma(data.item.chargeCount) }}
                </template>
                <template #cell(chargeEnergy)="data">
                  {{ $_utils.comma(data.item.chargeEnergy) }}
                </template>
                <template #cell(chargeCost)="data">
                  {{ $_utils.comma(data.item.chargeCost) }}
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </div>
      <!-- END Station Usage List -->
    </div>

  </div>
</template>

<script>
import infoCountTo from '@/views/components/infoCountTo.vue';
import cardTitle from '@/views/components/cardTitle.vue';
import Multiselect from 'vue-multiselect';
import SearchButtons from "@/views/components/searchButtons.vue";

export default {
  components: { SearchButtons, infoCountTo, cardTitle, Multiselect },
  data() {
    return {
      searchForm: {
        // period: [new Date(moment('2023-05-01', 'YYYY-MM-DD')), new Date(moment().subtract(1, 'd').format('YYYY-MM-DD'))],
        period: [
          moment().date(1).format('YYYY-MM-DD'),
          moment().subtract(1, 'days').format('YYYY-MM-DD')
        ],
        evseType: 'all',
        stationType: { 'value': 'all', 'text': '전체' },
        stationName: { 'value': 'all', 'text': '전체' }
      },
      evseTypeOptions: [
        { value: 'all', name: '전체' },
        { value: 'slow', name: '완속' },
        { value: 'fast', name: '급속' }
      ],
      result: {},
      chartBarOptions: {
        chart: {
          type: 'bar',
          toolbar: { show: false }
        },
        colors: ['#0d8600', '#eb5249', '#ffdf47', '#1763a4', '#fc8227', '#b35ca1', '#b56712', '#cae98b', '#122d59'],
        plotOptions: {
          bar: {
            columnWidth: '50px',
            distributed: true
          }
        },
        dataLabels: {
          enabled: false
        },
        legend: {
          show: false
        },
        tooltip: {
          y: {
            formatter: function(value, { series, seriesIndex, dataPointIndex, w }) {
              return value + ' 개'
            }
          }
        },
        xaxis: {
          datetimeUTC: false,
          categories: [],
          labels: {
            style: {
              fontSize: '13px'
            }
          }
        },
        series: [{
          name: '충전소',
          data: []
        }],
        noData: {
          text: 'Loading...',
          offsetY: -21,
          offsetX: 30,
          style: {
            color: '#858585',
          }
        }
      },
      typeSortBy: 'placeCount',
      typeSortDesc: true,
      fields: [
        { key: 'placeType', label: '유형' },
        { key: 'placeCount', label: '충전소', sortable: true },
        { key: 'evseCount', label: '충전기', sortable: true },
        { key: 'chargeUserCount', label: '이용자', sortable: true },
        { key: 'chargeCount', label: '이용', sortable: true },
        { key: 'chargeEnergy', label: '충전량', sortable: true },
        { key: 'chargeCost', label: '충전 금액', sortable: true }
      ],
      stationTypeOptions: [],
      stationNameOptions: [],
      chartResult: null,
      groupChartOptions: {
        stroke: {
          curve: 'straight',
          width: 2
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          type: 'datetime',
          datetimeUTC: false,
          categories: [],
          tickAmount: 10,
          labels: {
            format: 'MM/dd'
          },
          tooltip: {
            enabled: false
          }
        }
      },
      groupChartOptions1: {
        chart: {
          id: 'userCnt',
          group: 'station-group-chart'
        },
        colors: ['#47bce8'],
        title: {
          text: '이용자',
          align: 'left',
          style: {
            fontWeight: 'light',
            color:  '#000000'
          }
        },
        yaxis: {
          tickAmount: 4,
          labels: {
            formatter: function(val, index) {
              return Number(val).toLocaleString();
            }
          }
        },
        tooltip: {
          x: {
            format: 'yyyy-MM-dd'
          },
          y: {
            formatter: function(value, { series, seriesIndex, dataPointIndex, w }) {
              return Number(value).toLocaleString() + ' 명';
            }
          }
        },
        series: [{
          name: '이용자',
          data: []
        }],
        noData: {
          text: 'Loading...',
          offsetY: -17,
          offsetX: 30,
          style: {
            color: '#858585',
          }
        }
      },
      groupChartOptions2: {
        chart: {
          id: 'power',
          group: 'station-group-chart'
        },
        colors: ['#0576b9'],
        title: {
          text: '충전량',
          align: 'left',
          style: {
            fontWeight: 'light',
            color:  '#000000'
          }
        },
        yaxis: {
          tickAmount: 4,
          labels: {
            formatter: function(val, index) {
              return Number(val).toLocaleString();
            }
          }
        },
        tooltip: {
          x: {
            format: 'yyyy-MM-dd'
          },
          y: {
            formatter: function(value, { series, seriesIndex, dataPointIndex, w }) {
              return Number(value).toLocaleString() + ' kWh';
            }
          }
        },
        series: [{
          name: '충전량',
          data: []
        }],
        noData: {
          text: 'Loading...',
          offsetY: -17,
          offsetX: 30,
          style: {
            color: '#858585',
          }
        }
      },
      groupChartOptions3: {
        chart: {
          id: 'usageCnt',
          group: 'station-group-chart'
        },
        colors: ['#2cb57e'],
        title: {
          text: '이용',
          align: 'left',
          style: {
            fontWeight: 'light',
            color:  '#000000'
          }
        },
        yaxis: {
          tickAmount: 4,
          labels: {
            formatter: function(val, index) {
              return Number(val).toLocaleString();
            }
          }
        },
        tooltip: {
          x: {
            format: 'yyyy-MM-dd'
          },
          y: {
            formatter: function(value, { series, seriesIndex, dataPointIndex, w }) {
              return Number(value).toLocaleString() + ' 건';
            }
          }
        },
        series: [{
          name: '충전 이용',
          data: []
        }],
        noData: {
          text: 'Loading...',
          offsetY: -17,
          offsetX: 30,
          style: {
            color: '#858585',
          }
        }
      },
      useSortBy: 'chargeCount',
      useSortDesc: true,
      useAllFields: [
        { key: 'placeName', label: '충전소', show: 'station' },
        { key: 'csoEvseNum', label: '충전기 ID', show: 'evse' },
        { key: 'capacity', label: '충전 용량', show: 'evse' },
        { key: 'evseCount', label: '충전기', show: 'station' },
        { key: 'chargeUserCount', label: '이용자', show: 'all', sortable: true },
        { key: 'chargeCount', label: '이용', show: 'all', sortable: true },
        { key: 'chargeEnergy', label: '충전량', show: 'all', sortable: true },
        { key: 'chargeCost', label: '충전 금액', show: 'all', sortable: true }
      ],
      useFields: [],
      useItems: []
    }
  },
  created() {
    const vm = this;

    vm.groupChartOptions1 = { ...vm.groupChartOptions1, ...vm.groupChartOptions };
    vm.groupChartOptions2 = { ...vm.groupChartOptions2, ...vm.groupChartOptions };
    vm.groupChartOptions3 = { ...vm.groupChartOptions3, ...vm.groupChartOptions };
  },
  mounted() {
    const vm = this;

    vm.getItems();
    vm.searchCondition('placeType');
  },
  methods: {
    // reset() {
    //   const vm = this;
    //
    //   vm.searchForm = {
    //     period: [new Date(moment('2023-05-01', 'YYYY-MM-DD')), new Date(moment().subtract(1, 'd').format('YYYY-MM-DD'))],
    //     evseType: 'all',
    //     stationType: { 'value': 'all', 'text': '전체' },
    //     stationName: { 'value': 'all', 'text': '전체' }
    //   }
    //
    //   vm.searchCondition('placeType');
    //   vm.search();
    // },
    disabledAfterYesterday(date) {
      return date > moment().subtract(1, 'days');
    },
    search() {
      const vm = this;

      vm.getItems();
      vm.getChartItems();
    },
    getItems() {
      const vm = this;
      const _url = `/onmapi/stats/by-used`;

      if (this.$route.query.startDate) {
        vm.searchForm.period = [ this.$route.query.startDate, this.$route.query.endDate ];
      }

      this.$axios.get(_url, {
        params: {
          startDate: moment(vm.searchForm.period[0]).format('YYYY-MM-DD'),
          endDate: moment(vm.searchForm.period[1]).format('YYYY-MM-DD'),
          evseType: vm.searchForm.evseType
        }
      }).then((res) => {
        vm.result = Object.assign({}, res.data);

        if (this.result.usedChart.length > 0) {
          const categories = vm.result.usedChart.map(item => item.placeName);
          const chartData = vm.result.usedChart.map(item => item.placeCount);

          this.$refs.stationChart1.updateOptions({ xaxis: { categories: categories }, noData: { text: 'Loading...' } });
          this.$refs.stationChart1.updateSeries([{ data: chartData }]);
        } else {
          this.$refs.stationChart1.updateOptions({ xaxis: { categories: [] }, noData: { text: 'No Data' } });
          this.$refs.stationChart1.updateSeries([{ data: [] }]);
        }
      }).catch((error) => {
        //this.$swal('충전소 통계 데이터 조회 실패', '', 'error');
        console.error(error)
      });
    },
    searchCondition(val) {
      const vm = this;
      const _url = `/onmapi/stats/by-place/search/${val}`;

      this.$axios.get(_url, {
        params: {
          startDate: moment(vm.searchForm.period[0]).format('YYYY-MM-DD'),
          endDate: moment(vm.searchForm.period[1]).format('YYYY-MM-DD'),
          evseType: vm.searchForm.evseType,
          placeType: vm.searchForm.stationType.value
        }
      }).then((res) => {
        if (val === 'placeType') {
          vm.stationTypeOptions = res.data.items.map(item => ({
            value: item.placeType,
            text: item.placeTypeName
          }));
          vm.stationTypeOptions.unshift({ 'value': 'all', 'text': '전체' });

          vm.searchCondition('place');
        } else if (val === 'place') {
          vm.searchForm.stationName = { 'value': 'all', 'text': '전체' };

          vm.stationNameOptions = res.data.items.map(item => ({
            value: item.placeId,
            text: item.placeName
          }));
          vm.stationNameOptions.unshift({ 'value': 'all', 'text': '전체' });
        }

        vm.getChartItems();
      }).catch((error) => {
        //this.$swal('충전소 유형 or 충전소명 데이터 조회 실패', '', 'error');
        console.error(error)
      });
    },
    getChartItems() {
      const vm = this;
      const _url = `/onmapi/stats/by-place/chart`;

      if (this.$route.query.placeId && vm.stationNameOptions.length > 0) {
        vm.searchForm.stationName = vm.stationNameOptions.find(ele => ele.value === this.$route.query.placeId);
        this.$router.replace({ query: {} })
      }

      vm.getUseItems();

      this.$axios.get(_url, {
        params: {
          startDate: moment(vm.searchForm.period[0]).format('YYYY-MM-DD'),
          endDate: moment(vm.searchForm.period[1]).format('YYYY-MM-DD'),
          evseType: vm.searchForm.evseType,
          placeType: vm.searchForm.stationType.value,
          placeId: vm.searchForm.stationName.value
        }
      }).then((res) => {
        vm.chartResult = Object.assign({}, res.data);

        if (vm.chartResult.items.chartDatas.length > -1) {
          vm.drawGroupChart();
        }
      }).catch((error) => {
        //this.$swal('충전소 유형별 Chart 데이터 조회 실패', '', 'error');
        console.error(error)
      });
    },
    drawGroupChart() {
      const vm = this;

      let chartData1 = [];
      let chartData2 = [];
      let chartData3 = [];
      let categories = [];

      vm.chartResult.items.chartDatas.forEach(item => {
        categories.push(item.statsTime);

        chartData1.push(item.chargeUserCount);
        chartData2.push(item.chargeEnergy);
        chartData3.push(item.usedCount);
      });

      this.$refs.stationGroupChart1.updateOptions({
        xaxis: { categories: categories },
        noData: { text: chartData1.length > 0 ? 'Loading...' : 'No Data' }
      });
      this.$refs.stationGroupChart2.updateOptions({
        xaxis: { categories: categories },
        noData: { text: chartData2.length > 0 ? 'Loading...' : 'No Data' }
      });
      this.$refs.stationGroupChart3.updateOptions({
        xaxis: { categories: categories },
        noData: { text: chartData3.length > 0 ? 'Loading...' : 'No Data' }
      });

      this.$refs.stationGroupChart1.updateSeries([{ data: chartData1 }]);
      this.$refs.stationGroupChart2.updateSeries([{ data: chartData2 }]);
      this.$refs.stationGroupChart3.updateSeries([{ data: chartData3 }]);
    },
    getUseItems() {
      const vm = this;
      const _type = vm.searchForm.stationName.value === 'all' ? 'place' : 'evse';
      const _url = `/onmapi/stats/by-place/${_type}/list`;

      this.$axios.get(_url, {
        params: {
          startDate: moment(vm.searchForm.period[0]).format('YYYY-MM-DD'),
          endDate: moment(vm.searchForm.period[1]).format('YYYY-MM-DD'),
          evseType: vm.searchForm.evseType,
          placeType: vm.searchForm.stationType.value,
          placeId: vm.searchForm.stationName.value
        }
      }).then((res) => {
        vm.visibleFields();
        vm.useItems = res.data.items;
      }).catch((error) => {
        //this.$swal('충전소 or 충전기 이용 데이터 조회 실패', '', 'error');
        console.error(error)
      });
    },
    visibleFields() {
      const vm = this;
      vm.useFields = vm.useAllFields.filter(field => vm.showField(field));
    },
    showField(field) {
      const vm = this;

      if (vm.searchForm.stationName.value === 'all') {
        return field.show !== 'evse';
      } else {
        return field.show !== 'station';
      }

      return false;
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .apexcharts-toolbar {
    z-index: 0;
  }
}
</style>